import { render, staticRenderFns } from "./ClientQuoteMetadata.vue?vue&type=template&id=3633753a&scoped=true&"
import script from "./ClientQuoteMetadata.vue?vue&type=script&lang=js&"
export * from "./ClientQuoteMetadata.vue?vue&type=script&lang=js&"
import style0 from "./ClientQuoteMetadata.vue?vue&type=style&index=0&id=3633753a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3633753a",
  null
  
)

export default component.exports